import React from 'react';
import './TermsAndConditions.css';

const TermsAndConditions = () => {
  return (
    <div className="terms-container">
      <h3 className="terms-title">TERMS AND CONDITIONS</h3>

      <div className="terms-content">
        <h5>All payments should be made to</h5>
        <h5>SAGAMA CONSTRUCTION & ENGINEERING CO. LTD</h5>

        <div className="terms-section">
          <p>
            All payments made into our account and bank draft should be
            forwarded to the corporate office for issuance of receipt.
          </p>

          <p>
            Sagama Homes is not liable for losses incurred through cash payment
            made to unauthorized representatives.
          </p>

          <p>
            Please note that all refunds demanded would be subject to 5%
            administrative charges.
          </p>

          <p>Client are allowed 28 working days when demanding for refunds.</p>

          <p>All complaints forms must be returned to Sagama Homes.</p>

          <p>
            Facility Management of all estate developed by Sagama Homes will
            solely be managed by Sagama Construction & Engineering Co. Ltd.
          </p>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;
